import { ApplicationTypes, RectangularHole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  ArrowHeadType,
  detailComponent,
  dimensionIndicatorComponent,
  entityHeaderComponent,
  genericDimensionComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { RectangularHolePropertyPage } from '../ui/property-pages/RectangularHolePropertyPage'
import { bendHoleDimensionIndicatorCoordinates, scaleIndicator } from './common'

export const rectangularHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('RectangularHole')
    .attach(() => {
      return {
        title: featureLabels[RectangularHole.type],
        subtitle: 'Adjustable rectangular shape',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/rectangular-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('RectangularHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <RectangularHolePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('RectangularHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  // TODO: yaml
  attachComponent
    .withComponent(genericDimensionComponent, 'cornerRadius')
    .withEntity('RectangularHole')
    .attach(
      s => ({
        value: s.cornerRadius,
        min: 0.5,
        max: Math.min(s.height, s.width) / 2,
        unit: 'mm',
      }),
      v => {
        return {
          cornerRadius: v.value,
        }
      }
    ),
  // TODO: yaml
  attachComponent
    .withComponent(genericDimensionComponent, 'width')
    .withEntity('RectangularHole')
    .attach(
      s => ({
        value: s.width,
        min: 1,
        max: s.$plate.$maxFeatureSize.x,
        unit: 'mm',
      }),
      v => {
        return {
          width: v.value,
        }
      }
    ),
  // TODO: yaml
  attachComponent
    .withComponent(genericDimensionComponent, 'height')
    .withEntity('RectangularHole')
    .attach(
      s => ({
        value: s.height,
        min: 1,
        max: s.$plate.$maxFeatureSize.y,
        unit: 'mm',
      }),
      v => {
        return {
          height: v.value,
        }
      }
    ),
  attachComponent
    .withEntity('RectangularHole')
    .withComponent(dimensionIndicatorComponent, 'radius')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Finalization],
    })
    // TODO: memoEval
    .attach(s => ({
      ...bendHoleDimensionIndicatorCoordinates(s, {
        startX: s.$sizeX / 2,
        endX: s.$sizeX / 2,
        startY: s.$sizeY / 2,
        endY: s.$sizeY / 2,
        startZ: s.$plate.thickness + 0.1,
        endZ: s.$plate.thickness + 0.1,
        extrusionX: scaleIndicator(5, 50, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
      }),
      extrusionLineDashed: true,
      dashScale: 500,
      arrowHeadType: ArrowHeadType.CONE,
      arrowHeadSize: 6,
      labelFontSize: scaleIndicator(4, 64, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
      label: `R=${s.cornerRadius}`,
    })),
]
